import { Icon } from '../../../icons';
import styles from './unread-indicator.module.css';

const UnreadIndicator = () => (
  <Icon color="primary" icon="round-fill" size="extra-extra-small" spanClassName={styles.indicator} />
);

export default UnreadIndicator;
